import { PERSON_NAME_VALIDATION_MESSAGE, validatePersonName } from "shared/validators/name-validator"
import { toFrenchNationalPhone } from "shared/validators/phone-validator"
import { validateSIRET } from "shared/validators/siret-validator"
import * as Yup from "yup"
import { z } from "zod"

import { EMAIL_FORMAT_ERROR, PHONE_FORMAT_ERROR, SIRET_KEY_ERROR } from "@/utils/validation-messages"

// Même règle que le serveur (z.email() des modèles shared) : Yup.string().email() accepte a.b@c ou nom@domaine sans
// extension, que l'API rejette ensuite en 400.
export const emailValidation = (message = EMAIL_FORMAT_ERROR) => {
  return Yup.string().test("email", message, (email) => !email || z.email().safeParse(email).success)
}

export const phoneValidation = () => {
  return Yup.string().matches(/^[0-9]{10}$/, PHONE_FORMAT_ERROR)
}

// Accepte les écritures usuelles d'un numéro français (espaces, points, +33…) : toSubmittedPhone le ramène à 10 chiffres
export const frenchPhoneValidation = () => {
  return Yup.string().test("french-phone", PHONE_FORMAT_ERROR, (phone) => !phone || toFrenchNationalPhone(phone) !== null)
}

// Formik transmet à onSubmit les valeurs saisies, pas la sortie du schéma : la normalisation se fait à l'envoi
export const toSubmittedPhone = (phone: string | undefined) => (phone ? (toFrenchNationalPhone(phone) ?? phone) : "")

export const personNameValidation = () => {
  return Yup.string()
    .trim()
    .test("valid-person-name", PERSON_NAME_VALIDATION_MESSAGE, (value) => !value || validatePersonName(value))
}

export const SIRETValidation = () => {
  return Yup.string()
    .transform((value) => value.split(" ").join(""))
    .matches(/^[0-9]+$/, "Le siret est composé uniquement de chiffres")
    .min(14, "le siret est sur 14 chiffres")
    .max(14, "le siret est sur 14 chiffres")
    .test("test-luhn", SIRET_KEY_ERROR, (value) => validateSIRET(value))
}
